/**
 * @generated SignedSource<<77e4b0b58e28aa9e5d53040a80f638de>>
 * @relayHash 40dd05e6e4e493aa3b103cfde9170502
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3647f89a29157a20ed546e887d1178737c153b5f85382490e77e17398959a935

import type { ConcreteRequest } from 'relay-runtime';
export type LabelCountQuery$variables = {
  contentId: string;
  status?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type LabelCountQuery$data = {
  readonly singleContent: {
    readonly id: string | null | undefined;
    readonly labels: {
      readonly count: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type LabelCountQuery = {
  response: LabelCountQuery$data;
  variables: LabelCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
              "direction": "ASCENDING",
              "sortField": "LABELLING_CREATIONDATE"
            }
          }
        ],
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "count"
          }
        ],
        "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LabelCountQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LabelCountQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "40dd05e6e4e493aa3b103cfde9170502",
    "id": "3647f89a29157a20ed546e887d1178737c153b5f85382490e77e17398959a935",
    "metadata": {},
    "name": "LabelCountQuery",
    "operationKind": "query",
    "text": "query LabelCountQuery($contentId:ID!,$status:[String]){singleContent(id:$contentId,status:$status){id,labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count}}}"
  }
};
})();

(node as any).hash = "6b067ef7961ef1c9ac299658885db49d";

export default node;
